export const foodEmojis = [
  "🍇",
  "🍈",
  "🍉",
  "🍊",
  "🍋",
  "🍌",
  "🍍",
  "🥭",
  "🍎",
  "🍏",
  "🍐",
  "🍑",
  "🍒",
  "🍓",
  "🫐",
  "🥝",
  "🍅",
  "🫒",
  "🥥",
  "🥑",
  "🍆",
  "🥔",
  "🥕",
  "🌽",
  "🌶️",
  "🫑",
  "🥒",
  "🥬",
  "🥦",
  "🧄",
  "🧅",
  "🥜",
  "🫘",
  "🌰",
  "🫚",
  "🫛",
  "🍞",
  "🥐",
  "🥖",
  "🫓",
  "🥨",
  "🥯",
  "🥞",
  "🧇",
  "🧀",
  "🍖",
  "🍗",
  "🥩",
  "🥓",
  "🍔",
  "🍟",
  "🍕",
  "🌭",
  "🥪",
  "🌮",
  "🌯",
  "🫔",
  "🥙",
  "🧆",
  "🥚",
  "🍳",
  "🥘",
  "🍲",
  "🫕",
  "🥣",
  "🥗",
  "🍿",
  "🧈",
  "🧂",
  "🥫",
  "🍱",
  "🍘",
  "🍙",
  "🍚",
  "🍛",
  "🍜",
  "🍝",
  "🍠",
  "🍢",
  "🍣",
  "🍤",
  "🍥",
  "🥮",
  "🍡",
  "🥟",
  "🥠",
  "🥡",
  "🍦",
  "🍧",
  "🍨",
  "🍩",
  "🍪",
  "🎂",
  "🍰",
  "🧁",
  "🥧",
  "🍫",
  "🍬",
  "🍭",
  "🍮",
  "🍯",
];

export const drawingPrompts = [
  "draw a dumpster?",
  "maybe draw a sponge",
  "sketch this page!",
  "tell a secret!",
  "sketch the other person",
  "tell a joke!",
  "draw tomorrow - today!",
  "sketch your favorite sound!",
  "what happened today?",
  "what will happen tomorrow?",
  "sketch a toadstool",
  "draw something big that's typically small",
  "draw something small that's usually big",
  "sketch a midnight party!",
  "draw your hopes!",
  "find more time!",
  "a purple hedgehog?",
  "a silly pika?",
  "whatever's at the top of a hill!",
  "tell a (short) story!",
  "paint a mysterious frog?",
  "a inspired hen!",
  "a friendly pig!",
  "the weight of time.",
  "draw an early brunch!",
  "draw yourself!",
  "paint a new sound!",
  "a balancing act",
  "draw a really nice smile!",
  "a loud horn!",
  "a future without capitalism!",
  "a future without nations!",
  "a hope - a dream?",
  "that one thing you despise!",
  "draw more bonus time!",
];
